var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0909 8.5457C16.0909 13.6366 9.54545 18.0002 9.54545 18.0002C9.54545 18.0002 3 13.6366 3 8.5457C3 6.80974 3.68961 5.14487 4.91712 3.91736C6.14463 2.68985 7.80949 2.00024 9.54545 2.00024C11.2814 2.00024 12.9463 2.68985 14.1738 3.91736C15.4013 5.14487 16.0909 6.80974 16.0909 8.5457Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5451 10.7274C10.7501 10.7274 11.7269 9.75057 11.7269 8.54559C11.7269 7.3406 10.7501 6.36377 9.5451 6.36377C8.34011 6.36377 7.36328 7.3406 7.36328 8.54559C7.36328 9.75057 8.34011 10.7274 9.5451 10.7274Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.f631541f.svg";
export { ForwardRef as ReactComponent };